export default __webpack_public_path__ + "static/media/arrow.c25f3790.svg";